module.exports = __webpack_public_path__ + "img/swipe3-icon-active.f5e280a6.png";